module.exports = __webpack_public_path__ + "img/formF3.ffd38d80.svg";